import { Component, OnInit } from '@angular/core';
import {NavController,ToastController} from '@ionic/angular';
import { GlobalVars } from '../../../providers/globalVars';
import * as firebase from 'firebase/app';
import { AngularFireDatabase } from '@angular/fire/database';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-mypitem',
  templateUrl: './mypitem.page.html',
  styleUrls: ['./mypitem.page.scss'],
})
export class MypitemPage implements OnInit {
  itemlist:any = [];
  //lastdate:any;
  loaditemcnt:any = 15;
  loaddone:boolean = false;
  constructor(public navCtrl:NavController,private gv: GlobalVars, private translate: TranslateService,
    private toastCtrl: ToastController,public afDB: AngularFireDatabase) { }

  ngOnInit() {
    this.getdata();
  }
  
  getdata(){
    firebase.database().ref('/userData/' + this.gv.uid + '/pointitem')
    .orderByChild('createdDate')//.endAt(this.lastdate ? this.lastdate - 1 : 9999999999999)
        //.limitToLast(this.showcount)
        .once('value').then(rst=>{
         // if (rst.val() && rst.val()[Object.keys(rst.val())[0]].createdDate)
          //  this.lastdate = rst.val()[Object.keys(rst.val())[0]].createdDate;
      rst.forEach(r=>{
        this.itemlist.unshift({key:r.key, createdDate:r.val().createdDate, 
          pitemid:r.val().pitemid,
          used:this.afDB.object('/userData/' + this.gv.uid + '/pointitem/' + r.key + '/used'), 
          state:r.val().state,
          isappitem: r.val().isappitem,
          data:firebase.database().ref('/pmall/' + r.val().pitemid).once('value').then(a=>{return a.val()})})
      })
      this.loaddone = true;
    })
  }

  showprocessingmsg(){
    let txt; 
    this.translate.get('On processing.If needed use menu>enquiry.').subscribe(r=>txt=r);
    this.presentToast(txt);
  }

  async presentToast(message: string) {
    let toast = await this.toastCtrl.create({
      message: message,
      position: 'bottom',
      duration: 3000
    });
    toast.present();
  }

   doInfinite(infiniteScroll) {
    setTimeout(_=>{this.loaditemcnt = this.loaditemcnt + 15;infiniteScroll.target.complete()},80);
    }
}
